// Shared inventory helpers — pure functions, no React.

export function actionLabel(action: string): { text: string; color: string; bg: string } {
  switch (action) {
    case 'ADD':        return { text: 'Received',    color: 'var(--teal)',   bg: 'var(--teal-bg)' };
    case 'ISSUE':      return { text: 'Issued',      color: 'var(--blue)',   bg: 'var(--blue-bg)' };
    case 'RETURN':     return { text: 'Returned',    color: 'var(--purple)', bg: 'var(--purple-bg)' };
    case 'DELETE':     return { text: 'Deleted',     color: 'var(--red)',    bg: 'var(--red-bg)' };
    case 'RENAME':     return { text: 'Renamed',     color: 'var(--teal)',   bg: 'var(--teal-bg)' };
    case 'UPDATE':     return { text: 'Updated',     color: 'var(--amber)',  bg: 'var(--amber-bg)' };
    case 'MERGE_FROM': return { text: 'Merged from', color: 'var(--purple)', bg: 'var(--purple-bg)' };
    case 'MERGE_INTO': return { text: 'Merged into', color: 'var(--purple)', bg: 'var(--purple-bg)' };
    default:           return { text: action,        color: 'var(--text3)',  bg: 'var(--surface2)' };
  }
}

export function qtyDisplay(action: string, quantity: number): { symbol: string; color: string } {
  if (quantity === 0) return { symbol: '—', color: 'var(--text3)' };
  const isMinus = action === 'ISSUE' || action === 'DELETE' || action === 'MERGE_FROM';
  return { symbol: `${isMinus ? '−' : '+'}${quantity}`, color: isMinus ? 'var(--red)' : 'var(--teal)' };
}

export function resolveStaff(entry: any, staffMap: Record<string, string>): string {
  const notes = entry.notes || '';
  const performer = entry.performed_by || '';
  if (notes) {
    const match = notes.match(/(?:Issued to|Returned by):\s*(.+)/i);
    if (match) return match[1];
    return notes;
  }
  if (performer && performer.length > 20) return staffMap[performer] || 'System';
  if (performer) return performer;
  return '—';
}

export function getItemStats(log: any[], itemId: string) {
  const entries = log.filter(e => e.item_id === itemId);
  const totalIssued   = entries.filter(e => e.action === 'ISSUE').reduce((s, e) => s + e.quantity, 0);
  const totalReturned = entries.filter(e => e.action === 'RETURN').reduce((s, e) => s + e.quantity, 0);
  const totalReceived = entries.filter(e => e.action === 'ADD').reduce((s, e) => s + e.quantity, 0);
  return { totalIssued, totalReturned, totalReceived, totalTransactions: entries.length };
}
